module.exports = __webpack_public_path__ + "img/osint-horizontal.cd677e89.png";